export const filterEnabledCols = [
    "location_type",
    "location_name",
    "country",
    "timezone"
];
